import VegIcon from "./VegIcon";
import PrimaryButton from "./PrimaryButton";

export interface Dish {
  id: string;
  name: string;
  code: string | number;
  price: number;
  gross_price?: number;
  type: "veg" | "nonveg";
  currency?: string;
  isOutOfStock?: boolean;
  category_id?: string;
  today_special?: boolean;
}

interface Props {
  dish: Dish;
  quantity?: number;
  onAdd?: (dish: Dish) => void;
  onEdit?: (dish: Dish) => void;
  onIncrement?: (dish: Dish) => void;
  onDecrement?: (dish: Dish) => void;
}

const DishCard = ({ dish, quantity = 0, onAdd, onEdit, onIncrement, onDecrement }: Props) => {
  const currency = dish.currency ?? "₹";
  const outOfStock = dish.isOutOfStock === true;

  return (
    <article
      className={`bg-white rounded-[6px] shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-[#E6EEFF] p-3 relative h-[122px] flex flex-col justify-between ${outOfStock ? "opacity-60" : ""
        }`}
    >

      {/* Edit pencil top-right */}
      {/* <button
        type="button"
        aria-label={`Edit ${dish.name}`}
        onClick={() => onEdit?.(dish)}
        className="absolute top-2.5 right-2.5 w-6 h-6 flex items-center justify-center bg-transparent border-0"
      >
        <EditIcon />
      </button> */}
      {/* Out of Stock badge */}
      {outOfStock && (
        <span className="absolute top-2.5 right-2.5 bg-[#FF4444] text-white font-opensans font-semibold text-[10px] px-2 py-0.5 rounded-full">
          Out of Stock
        </span>
      )}

      <div className="flex flex-col justify-start flex-1 min-w-0">
        <div className={`flex items-start gap-2 ${outOfStock ? "pr-[74px]" : "pr-6"}`}>
          <span className="shrink-0 mt-0.5">
            <VegIcon type={dish.type} size={15} />
          </span>
          <h3 className="font-sansation font-bold text-[#111] text-[14px] lg:text-[15px] leading-tight line-clamp-2">
            {dish.name}
          </h3>
        </div>
      </div>

      <div className="mt-1">
        <p className="font-opensans uppercase text-[10px] tracking-[0.5px] text-[#8F9098] whitespace-nowrap truncate">
          Dish Code: {dish.code}
        </p>

        <div className="mt-1 flex items-center justify-between gap-2">
          <div className="flex items-center gap-1.5 mt-1">
            <p
              className="font-sansation font-bold text-[#F15A29] text-[15px] lg:text-[16px] whitespace-nowrap"
              aria-label={`Price ${currency} ${(dish.gross_price ?? dish.price).toFixed(2)}`}
            >
              {currency}{(dish.gross_price ?? dish.price).toFixed(2)}
            </p>

            {quantity > 0 && dish.gross_price !== undefined && dish.gross_price < dish.price && (
              <div className="border border-[#2E7D32] rounded-[4px] px-2.5 py-1 text-[#2E7D32] font-sansation font-bold text-[15px] leading-none flex items-center justify-center">
                {dish.price % 1 === 0 ? dish.price.toFixed(0) : dish.price.toFixed(2)}
              </div>
            )}
          </div>

          <div className="shrink-0">
            {outOfStock ? (
              // Out of stock — disabled button
              <button
                type="button"
                disabled
                className="h-[34px] rounded-[6px] px-2 inline-flex items-center gap-1 font-sansation font-bold text-[13px] uppercase border-0 cursor-not-allowed whitespace-nowrap"
                style={{ backgroundColor: "#D1D5DB", color: "#9CA3AF" }}
              >
                Out of Stock
              </button>
            ) : quantity > 0 ? (
              <div
                className="h-[34px] rounded-[6px] flex items-center justify-between px-3 gap-3"
                style={{ backgroundColor: "#F15A29" }}
              >
                <button
                  type="button"
                  aria-label={`Decrease ${dish.name}`}
                  onClick={() => onDecrement?.(dish)}
                  className="w-5 h-5 text-white font-bold text-[16px] bg-transparent border-0 leading-none"
                >
                  −
                </button>
                <span className="font-sansation font-bold text-white text-[14px] min-w-[14px] text-center">
                  {quantity}
                </span>
                <button
                  type="button"
                  aria-label={`Increase ${dish.name}`}
                  onClick={() => onIncrement?.(dish)}
                  className="w-5 h-5 text-white font-bold text-[16px] bg-transparent border-0 leading-none"
                >
                  +
                </button>
              </div>
            ) : (
              <PrimaryButton
                size="sm"
                variant="filled"
                fullWidth={false}
                onClick={() => onAdd?.(dish)}
                className="px-5 inline-flex items-center gap-1"
              >
                ADD <span className="text-[16px] leading-none">+</span>
              </PrimaryButton>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export default DishCard;
